<script setup lang="ts">
const toast = useToast();
const isSubmitting = ref(false);
const email = ref('');

definePageMeta({
  layout: 'default',
})

async function handleSubmit() {
  try {
    isSubmitting.value = true;
    
    const { error } = await useFetch('/api/mail', {
      method: 'POST',
      body: {
        email: email.value
      }
    });

    if (error.value) {
      throw error.value;
    }

    toast.add({
      id: 'success',
      color: 'green',
      icon: 'i-heroicons-check-circle',
      title: 'Email envoyé',
      description: 'Si un compte existe avec cet email, vous recevrez un lien de réinitialisation.',
    });

    setTimeout(() => {
      navigateTo('/auth/login');
    }, 3000);

  } catch (e: any) {
    toast.add({
      id: 'error',
      color: 'red',
      icon: 'i-heroicons-x-circle',
      title: 'Une erreur est survenue',
      description: e.message || 'Impossible de traiter votre demande. Veuillez réessayer plus tard.',
    });
  } finally {
    isSubmitting.value = false;
  }
}
</script>

<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
    <div class="max-w-md w-full space-y-8">
      <div>
        <h2 class="mt-6 text-center text-3xl text-gray-900">
          Mot de passe oublié
        </h2>
        <p class="mt-2 text-center text-sm text-gray-600">
          Entrez votre adresse email pour recevoir un lien de réinitialisation
        </p>
      </div>

      <UForm :state="{ email }" class="mt-8 space-y-6" @submit="handleSubmit">
        <UFormGroup label="Adresse email" required>
          <UInput
            v-model="email"
            type="email"
            autocomplete="email"
            required
            placeholder="exemple@email.com"
          />
        </UFormGroup>

        <div>
          <UButton
            type="submit"
            color="primary"
            block
            :loading="isSubmitting"
          >
            Envoyer le lien de réinitialisation
          </UButton>
        </div>

        <div class="text-center">
          <NuxtLink
            to="/auth/login"
            class="text-sm text-primary hover:text-primary-dark"
          >
            Retour à la connexion
          </NuxtLink>
        </div>
      </UForm>
    </div>
  </div>
</template>